import styled, { css } from 'styled-components';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

/**
 * ElementStyleEditor components
 *  */
export const StyleEditorContainer = styled.div`
  position: relative;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.whiteLilac};

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    /* if notch, add half a notch in left padding */
    padding-left: calc(10px + env(safe-area-inset-left) / 2);
  }
`;

export const StyleEditorHeader = styled.div`
  margin: 6px 0 14px 6px;
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  justify-content: space-between;
`;

export const StyleEditorMenuTrigger = styled.div``;

export const StyleEditorTitle = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  ${({ theme }) =>
    css`
      ${theme.mixins.font('bold', 16)}
    `}
  vertical-align: top;
  text-transform: capitalize;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.defaultActionBlue};
  }
`;

export const StyleAttributesContainer = styled.div`
  border-radius: 2px;
  background-color: #ffffff;

  margin-top: ${({ isPaint }) => (isPaint ? '28px' : '0')};
`;

export const StyleDivider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.sidebarGray};
`;

export const StyleFooter = styled.div`
  margin: 8px 0 0 10px;
`;

export const StyleElementCountText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.variationGray};
`;

export const StyleClearPaint = styled.div`
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
`;

/**
 * ElementStyleAttribute components
 *  */
export const StyleAttributeEditorContainer = styled.div`
  position: relative;
  border-radius: 2px;
  padding: 7px 10px;
  font-family: 'Gotham Book', 'Helvetica Neue', 'Arial', sans-serif;
  font-size: 12px;
  opacity: ${({ shouldDim }) => (shouldDim ? 0.2 : 1)};

  ${({ isSelected, theme }) => {
    if (isSelected) {
      return css`
        background-color: ${theme.colors.whiteLilacTwo};
      `;
    }
  }}

  ${({ isOverridden, theme }) => {
    return isOverridden
      ? css`
          ${StyleAttributeContent} {
            cursor: auto;
          }

          &::before {
            content: '';
            position: absolute;
            background-color: white;
            top: -1px;
            left: 36px;
            width: 20px;
            height: 20px;
            z-index: 1;
            border-radius: 20px;
          }

          &::after {
            content: '';
            position: absolute;
            background-color: #d58d39;
            top: 2px;
            left: 39px;
            width: 14px;
            height: 14px;
            z-index: 2;
            border-radius: 14px;
          }
        `
      : css`
        &:hover {
          ${StyleAttributeImage} {
            border-color: ${theme.colors.defaultActionBlue};

            ${StyleAttributeImageIcon} {
              display: inline-block;
            }
          }
      `;
  }}
`;

export const StyleAttributeImageIcon = styled.div`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.defaultActionBlue};

  svg path {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const StyleAttributeEditorIcon = styled.div`
  background-color: ${({ theme }) => theme.colors.gray};

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: not-allowed;
      `;
    }
  }}

  svg {
    margin: 0 auto;
    padding-top: 2px;

    path {
      fill: ${({ theme }) => theme.colors.variationGray};
    }
  }
`;

export const StyleAttributeImage = styled.div`
  position: relative;

  ${({ imageUrl, color, theme, isProductAttribute }) => {
    if (isProductAttribute || (!color && imageUrl)) {
      return css`
        background-size: cover;
        background-image: url(${imageUrl});
      `;
    }
    if (color) {
      return css`
        background-color: ${color};
      `;
    }
    return css`
      background-color: ${theme.colors.sidebarGray};
    `;
  }}

  ${StyleAttributeImageIcon} {
    display: none;
  }
`;

export const StyleAttributeText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 143px;
  padding: 5px 10px 0 0;
  vertical-align: middle;
  text-transform: capitalize;
  font-style: ${({ hasSelection }) => (!hasSelection ? 'italic' : 'normal')};

  ${({ disabled, theme }) => {
    if (disabled) {
      return css`
        color: ${theme.colors.mediumGrayTwo};
        cursor: not-allowed;
      `;
    }
  }}
`;

export const StyleAttributeContent = styled.div`
  display: inline-block;
  cursor: pointer;

  ${StyleAttributeImage}, ${StyleAttributeEditorIcon} {
    display: inline-block;
    margin-right: 8px;
    border: 1px solid
      ${({ isCallToAction, theme }) =>
        isCallToAction ? theme.colors.defaultActionBlue : theme.colors.mischka};
    border-radius: 2px;
    width: 38px;
    height: 22px;
    vertical-align: top;

    ${({ isCallToAction, theme }) => {
      return isCallToAction
        ? css`
            svg {
              path {
                fill: ${theme.colors.defaultActionBlue};
              }
            }
          `
        : '';
    }}
  }

  ${StyleAttributeText} {
    ${({ isCallToAction, theme }) => {
      return isCallToAction
        ? css`
            color: ${theme.colors.defaultActionBlue};
          `
        : '';
    }}
  }
`;
